export default __webpack_public_path__ + "static/media/QA_main_img.03b408eb.png";